
import { useContext, useState } from 'react';
import { Disclosure,  } from '@headlessui/react';
import { SearchIcon } from '@heroicons/react/solid';
import {  MenuIcon, XIcon } from '@heroicons/react/outline';
import ShiftSwitch from '../../providers/ShiftProviders/ShiftSwitch';
import { NavLink, Link } from 'react-router-dom';
import { ShiftContext } from '../../providers/ShiftProviders/ShiftProvider';

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function NavBar({ agents }) {
    const { shift } = useContext(ShiftContext);
    const [name, setName] = useState('');
  const [foundUsers, setFoundUsers] = useState('');
  
  const handleSearchClear = () => {
      setFoundUsers('')
      setName('');
  }

  const [focused, setFocused] = useState(true);
 
const filter = (e) => {
    const keyword = e.target.value;

    if (keyword !== '') {
      const results = agents.filter((agent) => {
        return agent.name.toLowerCase().includes(keyword.toLowerCase()) || agent.extensions.join().includes(keyword);
      });
      setFoundUsers(results);
    } else {
      setFoundUsers('');
    }
    setName(keyword);
  };

  return (
    <Disclosure as="nav" className="bg-gray-800">
      {({ open }) => (
        <>
          <div className="mr-6 mx-auto px-2 sm:px-4 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              <div className="flex items-center  px-2 lg:px-0">
                <div className="hidden lg:block  lg:ml-6">
                  <div className="flex space-x-4">
                    <NavLink
                      to="/"
                      exact
                      activeClassName="bg-gray-900 text-white"
                      className="text-gray-300  hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                    >
                      Dashboard
                    </NavLink>
                    <NavLink
                      to="/reports"
                      exact={false}
                      activeClassName="bg-gray-900 text-white"
                      className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                    >
                      Reports
                    </NavLink>
                  </div>
                </div>
              </div>
              <div className="flex-1 flex justify-center px-2 lg:ml-6 lg:justify-end">
                <div className="max-w-lg w-full lg:max-w-xs">
                  <label htmlFor="search" className="sr-only">
                    Search Agents
                  </label>
                  <div className="relative flex items-center">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-999">
                      <SearchIcon className="h-5 w-5 text-gray-400 z-1" aria-hidden="true" />
                    </div>
                    <div className="relative z-99">
                      <input
                        autoComplete="off"
                        id="search"
                        onBlur={() => setTimeout(() => setFocused(false), 100)}
                        onFocus={() => setFocused(true)}
                        name="search"
                        value={name}
                        onChange={filter}
                        className="block relative w-full pl-10 pr-3 py-2 border border-transparent rounded-md leading-5 bg-gray-700 text-gray-300 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-white focus:ring-white focus:text-gray-900 sm:text-sm"
                        placeholder={`Search Agents[${agents.length}] ... `}
                        type="search"
                      />
                      {foundUsers && foundUsers.length > 0 && focused ? (
                        <div className="absolute w-full mt-1 h-460 overflow-auto">
                          {foundUsers.map((agent) => (
                            <Link to={`/agent/${agent.id}`} key={agent.index}>
                              <div
                                className={classNames(
                                  'user-list bg-gray-200 hover:bg-gray-300 z-50 border-b border-blue-200 p-2 w-full animate-fade-in-down'
                                )}
                              >
                                <li
                                  onClick={handleSearchClear}
                                  className="agent list-none text-xs font-medium flex flex-col items-start"
                                >
                                  <div className="flex items-center mb-1">
                                    <img className="mr-1 max-w-1/10" src={agent.userImage} alt="Agent img" />
                                    <span className="agent-name">{agent.name}</span>
                                  </div>
                                  <div>
                                    {agent.extensions.map((extension) => (
                                      <span className="basic-badge bg-blue-500 text-white">{extension}</span>
                                    ))}
                                  </div>
                                </li>
                              </div>
                            </Link>
                          ))}
                        </div>
                      ) : null}
                    </div>
                    <div className="hidden lg:block lg:ml-4">
                      <div className="flex items-center mr-3">
                        <ShiftSwitch shift={shift} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex lg:hidden">
                {/* Mobile menu button */}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
            </div>
          </div>
          <Disclosure.Panel className="lg:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 flex items-center justify-between">
              <div>
                <NavLink
                  to="/"
                  className="focus:bg-gray-900 focus:text-white text-gray-300  hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  Dashboard
                </NavLink>
                <NavLink
                  to="/reports"
                  className="focus:bg-gray-900 focus:text-white text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium mt-0"
                >
                  Reports
                </NavLink>
              </div>
              <div className="lg:block lg:ml-4">
                <div className="flex items-center mr-3">
                  <ShiftSwitch shift={shift} />
                </div>
              </div>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
